import type { TypedMoney } from "@commercetools/platform-sdk";
import type { EnrichedSwarovskiProductVariantDiscountedPriceFrontend } from "@swo/shared";

export function hasDiscount(
  discountedPrice: EnrichedSwarovskiProductVariantDiscountedPriceFrontend,
): discountedPrice is TypedMoney {
  return (
    discountedPrice !== "no-discount-provided" &&
    discountedPrice !== "discount-not-applicable" &&
    discountedPrice !== "bundle-discount-tbd" &&
    discountedPrice !== "discount-calculated-at-cart" &&
    typeof discountedPrice.centAmount === "number"
  );
}
